import { render, staticRenderFns } from "./TabReconceptualizacion.vue?vue&type=template&id=0bcb6bc7&"
import script from "./TabReconceptualizacion.vue?vue&type=script&lang=js&"
export * from "./TabReconceptualizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports